import React, {useState, useEffect } from 'react'
import BackButton from '@/components/stepper/backbutton';
import ButtonAdminpanel from '@/components/ButtonAdminpanel';
import PlanCard from "@/pages/admin/Stepper/PlanCard";
import FeatureCard from '@/pages/admin/Stepper/FeatureCard';
import SkipButton from '@/components/stepper/skipbutton';

import { assignSupplierTrailPlan } from "@/actions/stepperAction";
import { connect } from "react-redux";
import { supplierPlanList } from '@/actions/subscriptionPlanAction';
import { isEqual, map } from 'lodash';
import axios from 'axios';
import API_URL from '@/constant/api.config';
import { useSearchParams } from 'react-router-dom';
import roles from '@/constant/roles.config';
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";

const ChoosePlan = (props) => {

  const [searchParams] = useSearchParams();
  const [member_supplier_id, setSupplierMemberID] = useState(null);
   
  const { supplierMember } = props;
  

  const [selectedPlan, setSelectedPlan] = useState();

  const [plans, setPlans] = useState([]);

 const [showLoader, setShowLoader] = useState(false);

  const trialPlanAssign = async () => {
    if (member_supplier_id) {
      setShowLoader(true);
      await props.assignPlan(member_supplier_id)
        .then((response) => {
          if (response === true) {
            console.log("add product successfully...");
            props.onSupplierUpdated();
            props.onNext();
          }
        })
        .catch((error) => {
          console.log(error);
        });
         setShowLoader(false);
    }
  };

  const getSubscriptionPlans = async () => {
     setShowLoader(true);
      await props.supplierPlanList().then((response) => {
          if(response.status) {
            setPlans(response.data);
            setSelectedPlan(response.data[1])
          }
      }).catch((err) => {
        console.log("Error ======== ", err);
      });
       setShowLoader(false);
  }

  const makePayment = async () => {
    let payReq = {
      member_id: props.supplier_id,
      email: supplierMember ? supplierMember.user_details.email : "",
      amount: selectedPlan ? selectedPlan.payable_amt : 0,
      plan_name: selectedPlan ? selectedPlan.name : "",
      plan_id: selectedPlan ? selectedPlan.id : 0,
      redirect_to: 'marketplace',
    }
    console.log("payReq",payReq);

     await axios.post(API_URL + '/stripe/create-payment-link', payReq ).then((response) => {
      if(response.status) {
        const paymentWindow =  window.open(response.data.url, '_blank');

        if (!paymentWindow) {
          alert("Please allow popups for this website.");
          return;
        }

        // const checkPaymentWindow = setInterval(() => {
        //   if(paymentWindow.closed) {
        //     clearInterval(checkPaymentWindow);
        //     window.location.reload();
        //   }
        // },500);
      }

      // if (response.data?.url) {
      //   const paymentWindow = window.open(
      //     response.data.url,
      //       "stripePayment",
      //       "width=500,height=800"
      //   );

      //   if (!paymentWindow) {
      //     alert("Please allow popups for this website.");
      //   }
      // }

    }).catch((err) => {
      console.log("Error =========== ", err);
    })
  }

  useEffect(() => {
    if (props.supplier_id) {
      setSupplierMemberID(props.supplier_id);
      getSubscriptionPlans();

    }
  }, [props.supplier_id]);

  useEffect(() => {
      setInterval(() => {

        let u = localStorage.getItem("user");
        u = JSON.parse(u);
        console.log("chooseplan ==================", u, " ============ ", supplierMember);
        if(!isEqual(u, supplierMember.user_details)) {
          if(u.role_slug.slug == "END_USER" && supplierMember.user_details?.page_type !== 'upgrade_plan') {
            window.location.href = `/${roles.ON_BOARDING.prefix}/supplier/${props.supplier_id}?payment=success`;
          }
          
        }
      },15000);
  },[supplierMember]);


  return (
       <div className='choose-plan-wrape'>
         {showLoader && <ScreenLoaderHome />}
         <div className='section-header skip-header'>
           <div className="section-content">
            <h2>Choose a Plan That Fits Your Business</h2>
            <p>
              Select a plan designed to help you reach more buyers and unlock more opportunities.
            </p>
            </div>
            <SkipButton onClick={supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name != null ? props.onNext : trialPlanAssign}/>
         </div>

          <div className="row g-3">
            {map(plans,(plan,index) => {

              if(plan.name != 'Trial') {
                return (<div className="col-xl-4 py-2" key={plan.id}>
                    <PlanCard
                      title={plan.name}
                      description={plan.description}
                      price={plan.payable_amt}
                      originalPrice={plan.price}
                      image={plan.image}
                      active={selectedPlan?.id === plan.id}
                      onClick={() => setSelectedPlan(plan)}
                    />
                  </div>)
              }
            })}
          </div>

          <div className=''>
          {
            selectedPlan && <FeatureCard planName={selectedPlan.name}  features={selectedPlan.features} />
          }
          </div>
         
         <div className='profile-button border-top'>
            {
              (supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name != null ) ? <></> : <BackButton className="mt-3 mx-3" type="submit" onClick={props.onPrev}>
                Back
            </BackButton>
            }
            
            <ButtonAdminpanel className="mt-3" type="button" onClick={makePayment}>
              Make Payment
            </ButtonAdminpanel>
         </div>
      </div>  
  )
}



const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    assignPlan: (member_id) => dispatch(assignSupplierTrailPlan(member_id)),
    supplierPlanList: () => dispatch(supplierPlanList())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChoosePlan);


